const MOBILE_BREAKPOINT = 768;
const DESKTOP_BREAKPOINT = 1920;
const UHD_BREAKPOINT = 3840;

const MOBILE_FONT_SIZE = 14;
const DESKTOP_FONT_SIZE = 16;
const UHD_FONT_SIZE = 18;

function lerp(value: number, inputStart: number, inputEnd: number, outputStart: number, outputEnd: number): number {
    const ratio = (value - inputStart) / (inputEnd - inputStart);
    return outputStart + (outputEnd - outputStart) * ratio;
}

export function getViewportFontSize(width: number): number {
    if (width <= MOBILE_BREAKPOINT) {
        return MOBILE_FONT_SIZE;
    }
    if (width <= DESKTOP_BREAKPOINT) {
        return lerp(width, MOBILE_BREAKPOINT, DESKTOP_BREAKPOINT, MOBILE_FONT_SIZE, DESKTOP_FONT_SIZE);
    }
    if (width >= UHD_BREAKPOINT) {
        return UHD_FONT_SIZE;
    }
    return lerp(width, DESKTOP_BREAKPOINT, UHD_BREAKPOINT, DESKTOP_FONT_SIZE, UHD_FONT_SIZE);
}

export function getAntdFontSize(rootFontSize: number): number {
    return Math.round(rootFontSize * 0.875);
}

export function getAntdControlHeight(fontSize: number): number {
    return Math.round(fontSize * 2.3);
}

export function getAntdBorderRadius(fontSize: number): number {
    return Math.max(6, Math.round(fontSize * 0.625));
}
